module.exports = __webpack_public_path__ + "img/logocio.018135ce.png";